import { render, staticRenderFns } from "./Passenger.vue?vue&type=template&id=a493ea5c&scoped=true"
import script from "./Passenger.vue?vue&type=script&lang=js"
export * from "./Passenger.vue?vue&type=script&lang=js"
import style0 from "./Passenger.vue?vue&type=style&index=0&id=a493ea5c&prod&lang=css"
import style1 from "./Passenger.vue?vue&type=style&index=1&id=a493ea5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a493ea5c",
  null
  
)

export default component.exports